import $ from "jquery";

const searchfilterRestructure = () => {
    const init = () => {
        handleSelectActive();
        moveSearchFormToNewWrapper();
        toggleSearchFilter();
        addBtnSearch();
    };

    const handleSelectActive = () => {
        const el = {
            main: '.mi-search-filter-form  .sf-input-select'
        }
        if ($(el.main).length === 0) return

        $(function ($) {
            $(el.main).each(function () {
                const select = $(this);

                // when on change
                select.on('change', function () {
                    select.toggleClass('option-selected');
                });
            });
        });
    };

    const moveSearchFormToNewWrapper = () => {
        const el = {
            targetSelector: '.mi-search-filter-form .sf-field-post-meta-job_remote',
            moveSelector: '.mi-search-filter-form .sf-field-post-meta-status',
        }

        const otherFields = [
            '.mi-search-filter-form .sf-field-taxonomy-job-language',
            '.mi-search-filter-form .sf-field-post-meta-job_work_load_from',
            '.mi-search-filter-form .sf-field-post-meta-job_duration'
        ];

        if ($(el.targetSelector).length === 0) return


        $(function ($) {
            // create new wrapper
            const newWrapperStatus = $(`
                <div class="mi-sf-status-wrapper">
                    <div class="mi-sf-status-toggle-btn">
                        <span>Status</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M13 6L8 11L3 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="mi-sf-status-wrapper__content" style="display: none;"></div>
                </div>
            `);

            // Insert wrapper after job_remote
            $(el.targetSelector).after(newWrapperStatus);

            // Move status into status content
            $(el.moveSelector).appendTo(newWrapperStatus.find('.mi-sf-status-wrapper__content'));

            // Toggle when button is clicked
            newWrapperStatus.find('.mi-sf-status-toggle-btn').on('click', function () {
                newWrapperStatus.find('.mi-sf-status-wrapper__content').fadeToggle(200);
            });

            // create new wrapper
            const newWrapperOthers = $(`
                <div class="mi-sf-others-wrapper">
                    <div class="mi-sf-others-toggle-btn">
                        <span>Mehr</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M13 6L8 11L3 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="mi-sf-others-wrapper__content" style="display: none;"></div>
                </div>
            `);

            // Insert wrapper 
            newWrapperStatus.after(newWrapperOthers);

            // move others form search into new div
            otherFields.forEach(selector => {
                const field = $(selector);

                if (field.length) {
                    newWrapperOthers.find('.mi-sf-others-wrapper__content').append(field);
                }
            });

            // Toggle when button is clicked
            newWrapperOthers.find('.mi-sf-others-toggle-btn').on('click', function () {
                const content = newWrapperOthers.find('.mi-sf-others-wrapper__content');
                content.fadeToggle(200);
            });

            $(document).on('click', function (e) {
                if (!$(e.target).closest('.mi-sf-status-wrapper').length) {
                    newWrapperStatus.find('.mi-sf-status-wrapper__content').fadeOut(200);
                }
                if (!$(e.target).closest('.mi-sf-others-wrapper').length) {
                    newWrapperOthers.find('.mi-sf-others-wrapper__content').fadeOut(200);
                }
            });
        });
    };

    const toggleSearchFilter = () => {
        const el = {
            btnSelector: '#toggleSearchFilter',
            searchFiler: '.mi-search-filter-form'
        }

        if ($(el.btnSelector).length === 0) return

        $(function ($) {
            // Toggle when button is clicked
            $(el.btnSelector).on('click', function () {
                $(el.searchFiler).fadeToggle(200);
            });
        });
    };

    const addBtnSearch = () => {
        const el = {
            main: '.mi-search-filter-form  .sf-field-search',
            targetSelectorBtn: '.mi-search-filter-form  .sf-field-search label',
            inputSelector: '.mi-search-filter-form  .sf-field-search .sf-input-text',
        }
        if ($(el.main).length === 0) return

        $(function ($) {
            const btnWrapper = $(`
                <div class="btn-search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M9.0625 15.625C12.6869 15.625 15.625 12.6869 15.625 9.0625C15.625 5.43813 12.6869 2.5 9.0625 2.5C5.43813 2.5 2.5 5.43813 2.5 9.0625C2.5 12.6869 5.43813 15.625 9.0625 15.625Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.7031 13.7031L17.5 17.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            `);

            $(el.targetSelectorBtn).after(btnWrapper);

            // btnWrapper.on('click', function () {
            //     const input = $(el.inputSelector);
            //     const e = $.Event("keyup");
            //     e.which = 65; // random keycode, misalnya 'a'
            //     input.val(input.val() + ' ').trigger('keyup').val(input.val().trim());
            // });
        });
    };

    init();
};

try {
    searchfilterRestructure();
} catch (error) {
    console.error('searchfilterRestructure', error);
}
